/* eslint-disable func-names */
/*
 * This search request obj gets passed to the vcda module in ws-scripts
 * to make parallel request to each service
 */

export const getSearchRO = (vehicleId, additionalMediaProperties = []) => {
	return {
		media: {
			uuid: vehicleId,
			select: ['images', 'videos', ...additionalMediaProperties]
		},
		vehicle: {
			rql: `&select(type,make,year,model,trim,bodyStyle,certified)&eq(uuid,${vehicleId})`
		}
	};
};

/*
 * Takes a URL and a map of URL parameters, and combines them into a full URL.
 */

export const buildUrlWithParams = (url, params = new Map()) => {
	if (!params.size) {
		return url;
	}
	const paramString = Array.from(params, keyValuePair =>
		keyValuePair.map(encodeURIComponent).join('=')
	).join('&');

	return `${url}?${paramString}`;
};
